module.exports = __webpack_public_path__ + "static/media/mantel_logo.085425f8.svg";